import { MatchFill } from '@lyearn/icons';
import { QuestionTypeEnum } from '@/types/schema';

import { QuizViewField } from '../../../types';
import { getQuestionEvaluation } from '../../../utils';
import Player from '../../Player';
import QuestionReview from '../../QuestionReview';
import { isValidMtfSubmission } from '../../utils';

const MatchThefollowingViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission: isValidMtfSubmission,
  Player,
  type: QuestionTypeEnum.MatchTheFollowing,
  getQuestionLabel: () => 'QuizPlayer:QuestionType.MatchTheFollowing',
  labelKey: 'QuizPlayer:QuestionType.MatchTheFollowing',
  Icon: MatchFill,
  Review: QuestionReview,
};

export default MatchThefollowingViewField;
